import { Pipe, PipeTransform } from '@angular/core';

/**
 * this pipe formats the date as so - if the date is today, return the time, else return the date
 */
@Pipe({
  name: 'customDateTime'
})
export class CustomDateTimePipe implements PipeTransform {
  public transform(value: string | Date) {
    const date = new Date(value);
    const now = new Date();

    const isToday =
      date.getDate() === now.getDate() &&
      date.getMonth() === now.getMonth() &&
      date.getFullYear() === now.getFullYear();

    if (isToday) {
      return date.toLocaleTimeString([], {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
    } else {
      return date.toLocaleDateString([], {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    }
  }
}
